import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialogModule } from "@angular/material/dialog";
import { MatDividerModule } from "@angular/material/divider";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatTabsModule } from "@angular/material/tabs";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import {
  LabelValueModule,
  OdqPhoneNumberModule,
  OdqPostalAddressModule,
  OdqToolboxModule,
} from "odq-toolbox";
import { UtilsModule } from "~app/inscription/cotisation-form/utils/utils.module";
import { FormNavigationModule } from "~app/shared/form-navigation/form-navigation.module";
import { SharedModule } from "~app/shared/shared.module";
import { ShoppingCartModule } from "~app/shopping-cart/shopping-cart.module";
import { ConfirmationPaymentComponent } from "./confirmation-payment/confirmation-payment.component";
import { PremiumMinimumComponent } from "./premium-minimum/premium-minimum.component";
import { PremiumComponent } from "./premium/premium.component";
import { ReclamationValidationDialogComponent } from "./reclamation-validation/reclamation-validation-dialog.component";
import { RegistrationCreditComponent } from "./registration-credit/registration-credit.component";
import { RegistrationPayment } from "./registration-payment/registration-payment.component";
import { RestartFormDialogComponent } from "./restart-form-dialog/restart-form-dialog.component";
import { SubscriptionFormComponent } from "./subscription-form.component";
import { SummaryComponent } from "./summary/summary.component";
import { SurplusInfoComponent } from "./surplus/surplus-info.component";
import { SurplusComponent } from "./surplus/surplus.component";
import { WelcomeComponent } from "./welcome/welcome.component";

@NgModule({
  declarations: [
    SubscriptionFormComponent,
    SurplusComponent,
    SummaryComponent,
    RegistrationPayment,
    PremiumMinimumComponent,
    ConfirmationPaymentComponent,
    WelcomeComponent,
    SurplusInfoComponent,
    RegistrationCreditComponent,
    PremiumComponent,
    RestartFormDialogComponent,
    ReclamationValidationDialogComponent
  ],
  imports: [
    SharedModule,
    CommonModule,
    MatCardModule,
    MatTabsModule,
    TranslateModule,
    FormNavigationModule,
    MatInputModule,
    MatCheckboxModule,
    MatDialogModule,
    FormsModule,
    ReactiveFormsModule,
    MatRadioModule,
    MatIconModule,
    MatButtonModule,
    RouterModule,
    MatDatepickerModule,
    MatSelectModule,
    UtilsModule,
    OdqPostalAddressModule,
    OdqPhoneNumberModule,
    LabelValueModule,
    MatDividerModule,
    MatProgressSpinnerModule,
    OdqToolboxModule,
    MatDialogModule,
    ShoppingCartModule,
  ],
})
export class SubscriptionFormModule {}
